"use strict";

// SOCIAL NETWORK FOOTER
var drop_down_footer = document.getElementById("block-socialmedialinks-footer");
var text_footer = document.getElementById("drop-down-footer-text");
var container_button = document.getElementById("drop-down-container-boton");
var ejemplo = 0;

if (
  container_button != null &&
  drop_down_footer != null &&
  text_footer != null
) {
  container_button.addEventListener("click", function() {
    if (ejemplo === 0) {
      drop_down_footer.style.display = "block";
      text_footer.style.display = "block";
      container_button.style.borderBottom = "0px";
      ejemplo = 1;
    } else {
      drop_down_footer.style.display = "none";
      text_footer.style.display = "none";
      container_button.style.borderBottom = "1px solid #88b0d3";
      ejemplo = 0;
    }
  });
}

// DROP DOWN SECTION INTERNAL-SEARCH
var title_contact = document.getElementById("section-share-title");
var icono_contact = document.getElementById("drop-down-share");
var content_contact = document.getElementById("section-share-drop-down");
var contact = 0;

if (title_contact != null && icono_contact != null && content_contact != null) {
  title_contact.addEventListener("click", function() {
    if (contact === 0) {
      content_contact.style.display = "block";
      icono_contact.style.transform = "rotate(180deg)";
      contact = 1;
    } else {
      content_contact.style.display = "none";
      icono_contact.style.transform = "rotate(360deg)";
      contact = 0;
    }
  });
}

var width = window.innerWidth;
var button_input = document.getElementById("edit-submit");
var content_contact_mobile = document.getElementById("section-share-drop-down");

if (width <= 1024) {
  if (button_input != null && content_contact_mobile != null) {
    button_input.addEventListener("click", function() {
      content_contact_mobile.style.display = "none";
      icono_contact.style.transform = "rotate(180deg)";
    });
  }
}

//menu centro de informacion -title

var container_menu_center = document.querySelector(".menu-center");

if (container_menu_center != null) {
  var title_menu_center = document.querySelector(".menu-center > h2");
  var newcaret_title_center = document.createElement("div");
  if (newcaret_title_center != null && title_menu_center != null) {
    newcaret_title_center.classList.add("caret-seab-menu");
    title_menu_center.appendChild(newcaret_title_center);
    title_menu_center.classList.add("father-menu-mobile");
  }

  var drop_down_center = document.querySelector(".father-menu-mobile");
  var switch_section_center = 0;
  if (drop_down_center != null) {
    drop_down_center.addEventListener("click", function() {
      if (switch_section_center == 0) {
        container_menu_center.classList.add("menu--active");
        switch_section_center = 1;
      } else {
        container_menu_center.classList.remove("menu--active");
        switch_section_center = 0;
      }
    });
  }
}
//menu centro de informacion _parte de abajo

var ejemplo2 = true;

var button_menu_b = document.querySelector(".icon-drop");
var content_menu_b = document.querySelector("#ul-menu-quienes-somos");
var ejemplo_menu_b = 0;

if (button_menu_b != null && content_menu_b != null) {
  button_menu_b.addEventListener("click", function() {
    if (ejemplo2) {
      if (ejemplo_menu_b == 0) {
        content_menu_b.classList.add("drop-down--block");
        ejemplo_menu_b = 1;
      } else {
        content_menu_b.classList.remove("drop-down--block");
        ejemplo_menu_b = 0;
      }
    } else {
      ejemplo2 = true;
    }
  });
}

//menu centro de informacion _parte de abajo _segundo nivel

var button_menu_second__level = document.querySelector(
  ".submenu .item-father .icon-drop"
);
var content_menu_second__level = document.querySelector(
  ".submenu .item-father"
);
var ejemplo_menu_second__level = 0;

if (button_menu_second__level != null && content_menu_second__level != null) {
  button_menu_second__level.addEventListener("click", function() {
    ejemplo2 = false;
    if (ejemplo_menu_second__level == 0) {
      content_menu_second__level.classList.add("drop-down--block");
      ejemplo_menu_second__level = 1;
    } else {
      content_menu_second__level.classList.remove("drop-down--block");
      ejemplo_menu_second__level = 0;
    }
  });
}

//drop-down information-center
var box_title = document.querySelector(".section-news--title__drop-down");
var content_section_news = document.querySelector(".section-news");
var switch_section_news = 0;

if (box_title != null && content_section_news != null) {
  box_title.addEventListener("click", function() {
    if (switch_section_news == 0) {
      content_section_news.classList.add("section-news--active");
      switch_section_news = 1;
    } else {
      content_section_news.classList.remove("section-news--active");
      switch_section_news = 0;
    }
  });
}

//drop-down introduction
var box_title_introduction = document.querySelector(
  ".introduction-content-mobile"
);
var content_section_introduction = document.querySelector(
  ".introduction--content"
);
var switch_section_introduction = 0;

if (box_title_introduction != null && content_section_introduction != null) {
  box_title_introduction.addEventListener("click", function() {
    if (switch_section_introduction == 0) {
      content_section_introduction.classList.add("introduction--active");
      switch_section_introduction = 1;
    } else {
      content_section_introduction.classList.remove("introduction--active");
      switch_section_introduction = 0;
    }
  });
}

//drop-down alfabeto
var box_title_alphabet = document.querySelector(".section-alphabet--title");
var content_section_alphabet = document.querySelector(".alphabet");
var switch_section_alphabet = 0;

if (box_title_alphabet != null && content_section_alphabet != null) {
  box_title_alphabet.addEventListener("click", function() {
    if (switch_section_alphabet == 0) {
      content_section_alphabet.classList.add("alphabet--active");
      switch_section_alphabet = 1;
    } else {
      content_section_alphabet.classList.remove("alphabet--active");
      switch_section_alphabet = 0;
    }
  });
}

///// DROP-DOWN PREFOOTER

var icon_prefooter = document.querySelector(".drop-down-prefooter");
var container_prefootert = document.querySelector(".pre-footer");
var switch_prefootert = 0;

if (icon_prefooter != null && container_prefootert != null) {
  icon_prefooter.addEventListener("click", function() {
    if (switch_prefootert == 0) {
      container_prefootert.classList.add("active--prefooter");
      switch_prefootert = 1;
    } else {
      container_prefootert.classList.remove("active--prefooter");
      switch_prefootert = 0;
    }
  });
}

/// DROP-DOWN SOCIAL NETWORKS

(function($, Drupal, drupalSettings) {
  Drupal.behaviors.myBehavior_prepa = {
    attach: function(context, settings) {
      // const actions = document.querySelector(
      //   ".contextual-region .views-infinite-scroll-content-wrapper"
      // );
      // if (context === actions) funcion_nn();

      var button_share = document.querySelectorAll(
        ".container-content__network .share"
      );
      var content_network = document.querySelectorAll(
        ".container-content__network"
      );
      var switch_share = new Array(button_share.length);

      var arr = Array.from(content_network);

      if (
        button_share != null &&
        content_network != null &&
        switch_share != null
      ) {
        var _loop = function _loop(i) {
          button_share[i].addEventListener("click", function() {
            if (switch_share[i] == undefined || switch_share[i] == 0) {
              arr[i].classList.add("network--active");
              switch_share[i] = 1;
            } else {
              arr[i].classList.remove("network--active");
              switch_share[i] = 0;
            }
          });
        };

        for (var i = 0; i < button_share.length; i++) {
          _loop(i);
        }
      }

      var button_share1 = document.querySelectorAll(
        ".views-field-addtoany-share .share"
      );
      var content_network1 = document.querySelectorAll(
        ".views-field-addtoany-share"
      );
      var switch_share1 = new Array(button_share1.length);

      var arr1 = Array.from(content_network1);

      if (
        button_share1 != null &&
        content_network1 != null &&
        switch_share1 != null
      ) {
        var _loop2 = function _loop2(i) {
          button_share1[i].addEventListener("click", function() {
            if (switch_share1[i] == undefined || switch_share1[i] == 0) {
              arr1[i].classList.add("network--active");
              switch_share1[i] = 1;
            } else {
              arr1[i].classList.remove("network--active");
              switch_share1[i] = 0;
            }
          });
        };

        for (var i = 0; i < button_share1.length; i++) {
          _loop2(i);
        }
      }

      var button_share2 = document.querySelectorAll(
        ".block-addtoany-block .share"
      );
      var content_network2 = document.querySelectorAll(".block-addtoany-block");
      var switch_share2 = new Array(button_share2.length);

      var arr2 = Array.from(content_network2);

      if (
        button_share2 != null &&
        content_network2 != null &&
        switch_share2 != null
      ) {
        var _loop3 = function _loop3(i) {
          button_share2[i].addEventListener("click", function() {
            if (switch_share2[i] == undefined || switch_share2[i] == 0) {
              arr2[i].classList.add("network--active");
              switch_share2[i] = 1;
            } else {
              arr2[i].classList.remove("network--active");
              switch_share2[i] = 0;
            }
          });
        };

        for (var i = 0; i < button_share2.length; i++) {
          _loop3(i);
        }
      }
    }
  };
})(jQuery, Drupal, drupalSettings);

/// drop-down pagina contacto-general
let contact_header = document.querySelector(".section-contact-new h2");
if (contact_header != null) {
  contact_header.addEventListener("click", function() {
    let father_this = contact_header.closest(".section-contact-new");
    father_this.classList.toggle("active");
  });
}

//drop-down plan-E mobile text

var button_more_text = document.querySelector(".button-more-text");
var container_plan = document.querySelector(".information-plan");
var switch_text_planE = 0;

if (button_more_text != null && container_plan != null) {
  button_more_text.addEventListener("click", function() {
    if (switch_text_planE == 0) {
      container_plan.classList.add("more-text");
      switch_text_planE = 1;
    } else {
      container_plan.classList.remove("more-text");
      switch_text_planE = 0;
    }
  });
}

//# sourceMappingURL=drop_down.arquidiocesis.script.js.map
